<template>
   <tr class="dr">
     <td> {{ datum.origin.label }}</td>
     <td class="dr"> <a class="dr" :href="datum.origin.IRI" target="_blank"> {{ datum.origin.ID }}</a></td>
     <td> {{ datum.destination.label || "-" }}</td>
     <td class="dr"><a class="dr" :href="datum.destination.IRI" target="_blank">{{ datum.destination.ID }}</a></td>
     <td>{{ datum.via ? datum.via.label : "-" }}</td>
     <td class="dr"><a class="dr" :href="datum.via.IRI" target="_blank">{{ datum.via.ID }}</a></td>
   </tr>
</template>

<script>

  export default {
    props: ['datum']
  }

</script>

<style scoped>
  .dr {
    background-color: #EFF5FB;
    padding: 8px;
    text-align: left;
  }
    
</style>